import { DEFAULT_PROJECT_NAME, useResources } from '@resources/index';

import type { HNVerktoyFrontend } from '@src/types/Resources';

export const useGetResources = (projectName: string = DEFAULT_PROJECT_NAME): HNVerktoyFrontend | undefined => {
  const resources = useResources<HNVerktoyFrontend>(projectName);
  return resources ?? undefined;
};
